// extracted by mini-css-extract-plugin
module.exports = {"container":"AddPaymentMethod_container__lePqR","titleContainer":"AddPaymentMethod_titleContainer__3FyXn","cta":"AddPaymentMethod_cta__2rdR4"};